import * as React from 'react';
import { Column } from 'react-data-grid';
import UnitSensorEdit from './UnitSensorEdit';
import './UnitSensor.scss';
import Container from '../Generic/Container';
import UnitName from 'src/container/Unit/UnitName';
// import SensorTypeName from 'src/container/SensorType/SensorTypeName';
import DatetimeRenderer from '../../components/DatetimeRenderer';
import FixedNumber from '../../components/FixedNumber';

const columns: Array<Column> = [
  {
    key: 'unitId',
    name: 'Unit',
    filterable: false,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: UnitName
  },
  {
    key: 'name',
    name: 'Name',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
  },
  {
    key: 'lastValue',
    name: 'Last Value',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: FixedNumber
  },
  {
    key: 'lastUpdate',
    name: 'Last Updated',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: DatetimeRenderer
  },
  {
    key: 'min',
    name: 'Minimum Value',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: FixedNumber
  },
  {
    key: 'max',
    name: 'Maximum Value',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: FixedNumber
  },
  {
    key: 'total',
    name: 'Total',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: FixedNumber
  },
  {
    key: 'average',
    name: 'Average Value',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: FixedNumber
  }
];
function renderEdit({ resolveRow, rejectRow, fromObject, isNew }: any) {
  return (
    <UnitSensorEdit  
      resolveRow={resolveRow}
      rejectRow={rejectRow}
      fromObject={fromObject}
      isNew={isNew}
    />
  );
}

export default Container(
  columns, 
  'unitsensors', 
  renderEdit,
  ({isSuperUser}) => ({
    name: 'Unit Sensors',
    icon: 'thermometer half',
    enableFilter: true,
    enableAddRow: false,
    enableDeleteRow: false
  }),
  ({clientId}) => {
    return  {};
  },
);


// WEBPACK FOOTER //
// ./src/container/UnitSensor/UnitSensor.tsx